import { makeStyles } from 'tss-react/mui';

const useStylesTableCellStackChartSingle: MaterialUIStylesCallback = makeStyles()((): MaterialUIStyles => ({
  tableCellStackChartSingle: {
    padding: '10px 0 !important',
    maxWidth: 60,
    '&:last-child': {
      paddingRight: 0,
    },
  },
}));

export default useStylesTableCellStackChartSingle;
